import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DarkModeContextType {
  	isDark: boolean;
  	toggleDarkMode: () => void;
}

const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined);

export const useDarkMode = () => {
  	const context = useContext(DarkModeContext);
  	if(context === undefined){
    	throw new Error('useDarkMode must be used within a DarkModeProvider');
  	}
  	return context;
};

interface DarkModeProviderProps {
  	children: ReactNode;
}

export const DarkModeProvider: React.FC<DarkModeProviderProps> = ({ children }) => {
  	const [isDark, setIsDark] = useState(() => {
    	const saved = localStorage.getItem('darkMode');
    	return saved ? JSON.parse(saved) : true; // Default dark mode
  	});

  	useEffect(() => {
    	localStorage.setItem('darkMode', JSON.stringify(isDark));
    	if(isDark){
      		document.documentElement.classList.add('dark');
    	}else{
      		document.documentElement.classList.remove('dark');
    	}
  	}, [isDark]);

  	const toggleDarkMode = () => {
    	setIsDark(!isDark);
  	};

  	const value: DarkModeContextType = { isDark, toggleDarkMode };

  	return <DarkModeContext.Provider value={value}>{children}</DarkModeContext.Provider>;
};
